import { render, staticRenderFns } from "./CustomFormPreview.vue?vue&type=template&id=d2427cae&scoped=true"
import script from "./CustomFormPreview.vue?vue&type=script&lang=ts"
export * from "./CustomFormPreview.vue?vue&type=script&lang=ts"
import style0 from "./CustomFormPreview.vue?vue&type=style&index=0&id=d2427cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2427cae",
  null
  
)

export default component.exports